import { useEffect, useState } from "react";
import { Link, useLocation } from "wouter";
import { Button } from "./ui/button";
import { getConsent, setConsent } from "@/lib/tracking";

export function ConsentBanner() {
  const [location] = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(getConsent() === null);
  }, []);

  if (!visible || location.startsWith("/admin")) return null;

  const choose = (choice: "granted" | "denied") => {
    setConsent(choice);
    setVisible(false);
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] p-4 sm:p-6">
      <div className="mx-auto max-w-3xl rounded-xl border border-white/10 bg-background/95 backdrop-blur-md shadow-2xl">
        <div className="flex flex-col gap-4 p-5 sm:flex-row sm:items-center sm:justify-between sm:gap-6">
          <p className="text-sm text-muted-foreground leading-relaxed">
            We use privacy-friendly, anonymous analytics to understand how our site is used. No
            tracking runs until you agree. See our{" "}
            <Link
              href="/privacy"
              className="text-secondary underline underline-offset-2 hover:text-primary"
            >
              Privacy Policy
            </Link>
            .
          </p>
          <div className="flex flex-shrink-0 items-center gap-3">
            <button
              onClick={() => choose("denied")}
              className="text-xs font-heading uppercase tracking-widest text-muted-foreground hover:text-foreground transition-colors"
            >
              Decline
            </button>
            <Button
              size="sm"
              onClick={() => choose("granted")}
              className="bg-primary hover:bg-primary/90 text-primary-foreground font-heading tracking-widest text-xs h-8 px-5 rounded-full"
            >
              Accept
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
